
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applications/[applicationId]/settings/experiments",
      function () {
        return require("private-next-pages/applications/[applicationId]/settings/experiments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/applications/[applicationId]/settings/experiments"])
      });
    }
  